import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import crmService from "../../crmConfig.json";
import { crmAxios } from "../../app/crmApi";
import { errorToast, successToast } from "../../helpers/toaster";

const initialState = {
    policies: [],
    loading: false,
    saving: false,
};

export const fetchPoliciesAsync = createAsyncThunk(
    "crmPolicy/fetchPolicies",
    async (_, { rejectWithValue }) => {
        try {
            const res = await crmAxios.get(crmService.adminPolicies);
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

export const savePolicyAsync = createAsyncThunk(
    "crmPolicy/savePolicy",
    async ({ audience, type, payload }, { rejectWithValue }) => {
        try {
            const res = await crmAxios.put(
                `${crmService.adminPolicies}/${audience}/${type}`,
                payload
            );
            return res.data;
        } catch (err) {
            return rejectWithValue(err.response?.data);
        }
    }
);

const crmPolicySlice = createSlice({
    name: "crmPolicy",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPoliciesAsync.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchPoliciesAsync.fulfilled, (state, { payload }) => {
                state.loading = false;
                if (payload?.success) state.policies = payload.data;
            })
            .addCase(fetchPoliciesAsync.rejected, (state) => {
                state.loading = false;
            })
            .addCase(savePolicyAsync.pending, (state) => {
                state.saving = true;
            })
            .addCase(savePolicyAsync.fulfilled, (state, { payload }) => {
                state.saving = false;
                if (payload?.success) {
                    successToast(payload.message);
                    const idx = state.policies.findIndex(
                        (p) =>
                            p.audience === payload.data.audience &&
                            p.type === payload.data.type
                    );
                    if (idx >= 0) state.policies[idx] = payload.data;
                    else state.policies.push(payload.data);
                } else {
                    errorToast(payload?.message || "Save failed");
                }
            })
            .addCase(savePolicyAsync.rejected, (state, { payload }) => {
                state.saving = false;
                errorToast(payload?.message || "Save failed");
            });
    },
});

export const selectPolicies = (state) => state.crmPolicy.policies;
export const selectPolicyLoading = (state) => state.crmPolicy.loading;
export const selectPolicySaving = (state) => state.crmPolicy.saving;

export default crmPolicySlice.reducer;
